import React, { useState, useRef, useEffect } from 'react';
import { Input, Form, Select, Button } from 'Components';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import Pill from "Components/Pill";

const CreateEditOfflineDevice = (props) => {

    const { onSubmit, handleClose } = props;
    const dispatch = useDispatch();
    const { messages,locale } = useIntl();
    const editCreateDashboardGadgets = useRef();
    const [formData, setFormData] = useState({});
    const [thresholdSelected, setThresholdSelected] = useState('Hours');


    const optionsFleet = [{
            id: 'Fleet',
            name: messages['realtimemaps_map_settings_offline_fleet']
        },
        {
            id: 'Asset',
            name: messages['realtimemaps_map_settings_offline_asset']
        }
    ];

    const optionsFrecuency = [{
        id: 300,
        name: `5 ${messages['dashboardPanel_edit_minutes']}`
    }, {
        id: 900,
        name: `15 ${messages['dashboardPanel_edit_minutes']}`
    }, {
        id: 1800,
        name: `30 ${messages['dashboardPanel_edit_minutes']}`
    },
    {
        id: 3600,
        name: `1 ${messages['dashboardPanel_edit_hours']}`
    },
    {
        id: 7200,
        name: `2 ${messages['hours']}`
    }];

    const {
        loadingCreateEdit,
        gadGet,
    } = useSelector((state) => state.dashboardPanelRedux);


    useEffect(() => {
        if (gadGet.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setThresholdSelected(settings.thresholdSelected)
            setFormData({
                ...formData,
                name: gadGet.name,
                fleet: optionsFleet.filter(fleet => fleet.id == settings.fleet.id)[0],
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0]
            })
        } else {
            setFormData({
                ...formData
            })
        }
    }, [open, gadGet])

    useEffect(() => {
        if(formData?.fleet?.id){
            setFormData({
                ...formData,
                fleet: optionsFleet.filter(fleet => fleet.id == formData.fleet.id)[0],
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === formData.refreshSeconds.id)[0]
            }) 
        }
    }, [locale])


    useEffect(() => {
        if (gadGet.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setThresholdSelected(settings.thresholdSelected)
            setFormData({
                ...formData,
                name: gadGet.name,
                fleet: optionsFleet.filter(fleet => fleet.id == settings.fleet.id)[0],
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0]
            })
        }
    }, [open, gadGet])

    const validateData = () => {
        onSubmit({
            ...formData,
            thresholdSelected: thresholdSelected,
            refreshSeconds: formData.refreshSeconds.id
        })
    }

    return (
        <div style={{ padding:'15px 20px 20px 20px' }}>
            <Form
                ref={editCreateDashboardGadgets}
                onValidSubmit={validateData}>
                <div >
                    <label className="input-normal-label" style={{ marginTop: 18 }}>
                        {messages['dashboardPanel_edit_title']}
                        <span className="text-danger"> *</span>
                    </label>
                    <Input
                        id="name"
                        value={formData.name || ""}
                        onChange={(value) => {
                            setFormData({ ...formData, name: value });
                        }}
                        minLength={1}
                        maxLength={25}
                        type="text"
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
                <div style={{ paddingTop: 26 }}>
                    <label className="input-normal-label" style={{ marginTop: 18 }}>
                        {messages['dashboardPanel_edit_frequency']}
                        <span className="text-danger"> *</span>
                    </label>
                    <Select
                        id="refreshSeconds"
                        loading={loadingCreateEdit}
                        options={optionsFrecuency}
                        textField="name"
                        valueField="id"
                        placeholder={messages['mapGeofenceUnitGeofence_selectPlaceholder']}
                        isSearchable={false}
                        value={formData.refreshSeconds}
                        onChange={(value) => {
                            setFormData({ ...formData, refreshSeconds: value });
                        }}
                        isClearable
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
                <div style={{ paddingTop: 26 }}>
                    <label className="input-normal-label" style={{ marginTop: 18 }}>
                        {messages['dashboardPanel_edit_fleet']}
                        <span className="text-danger"> *</span>
                    </label>
                    <Select
                        id="fleet"
                        loading={loadingCreateEdit}
                        options={optionsFleet}
                        textField="name"
                        valueField="id"
                        isSearchable={false}
                        value={formData?.fleet}
                        placeholder={messages['mapGeofenceUnitGeofence_selectPlaceholder']}
                        onChange={(value) => {
                            setFormData({ ...formData, fleet: value });
                            if (value.id == 'Asset') {
                                setThresholdSelected('Days');
                            }
                        }}
                        isClearable
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
            </Form>
            <div style={{
                bottom: 0,
                position: 'fixed',
                padding: 15
            }}>
                <Button
                    disabled={loadingCreateEdit}
                    className="btn-cancel"
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        handleClose();
                    }}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    disabled={loadingCreateEdit}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editCreateDashboardGadgets.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </div>
        </div>

    );
}

export default CreateEditOfflineDevice;